import { queryOrgList } from 'liyu-pc-base/api/sys';

export default () => {
  const search_config: any = {
    model: {},
    watch: [],
  };
  return {
    getData: queryOrgList,
    searchConfig: search_config,
  };
};
